<template>
  <v-list-item three-line>
    <v-list-item-content @click="apri_dett()">
      <v-list-item-title :class="ordine.nuovo ? 'font-weight-bold' : ''">
        Ordine # {{ ordine.numero }} del {{ ordine.data }}
      </v-list-item-title>
      <v-list-item-subtitle class="text-decoration-underline text-truncate">
        {{ ordine.cliente }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        <v-icon :color="stato.color" size="15" class="mr-2">{{
          stato.mdi
        }}</v-icon
        >{{ stato.text }}
        <v-icon
          v-if="ordine.contabilizzato"
          size="10"
          class="ml-0"
          :color="tipo_contabilizzato"
          >mdi-circle</v-icon
        >
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="!ordine.visibile">
        <v-icon size="15" class="mr-2">mdi-eye-off</v-icon>Nascosto
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="ordine.is_joined">
        <v-icon color="amber" size="15" class="mr-2">mdi-merge</v-icon>Unito
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        Consegna:
        <span :class="ordine.ritiro_cod == 1 ? 'green--text' : 'blue--text'">{{
          ordine.ritiro_cod == 1 ? "Nostra" : "Ritiro"
        }}</span>
        - cc: {{ tot_cc }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-list-item-action-text v-if="ordine.nuovo" class="green--text"
        >Nuovo</v-list-item-action-text
      >
      <MenuOpzioni :ordine="ordine" />
    </v-list-item-action>
    <OrdineDettaglio :ordine="ordine" ref="dett_ordine" />
  </v-list-item>
</template>

<script>
import OrdineDettaglio from "./ordine_dettaglio/ordine_dettaglio_mobile.vue";
import ordine_attivo_mixin from "../mixin/ordine_attivo_element_mixin";
import MenuOpzioni from "../common/menu_opzioni.vue";

export default {
  components: {
    MenuOpzioni,
    OrdineDettaglio,
  },
  mixins: [ordine_attivo_mixin],
  props: {
    ordine: Object,
  },
  data() {
    return {
      loading_conferma: false,
      loading_elimina: false,
      dialog_delete: false,
      menu_opzioni: false,
    };
  },
  computed: {
    ritiro() {
      switch (this.ordine.ritiro_cod) {
        case 1:
          return { text: "Consegna", color: "blue", cod: 1 };
        case 0:
          return { text: "Ritiro", color: "green", cod: 0 };
      }
      return { text: "err", color: "red" };
    },
  },
  methods: {
    apri_dett() {
      this.$refs.dett_ordine.open();
    },
  },
};
</script>